export default "/img/BE.82307a60e6faa0b2271d702e0896c61d.png";